module.exports = __webpack_public_path__ + "static/media/exampleTemplate.df66ef98.png";